import React from 'react';
import PageLayout from '../../layout/PageLayout';
import InformationOfRegistration from '../../layout/InformationOfRegistration/InformationOfRegistration';

const InformationOfRegistrationPage: React.FC = () => (
  <PageLayout>
    <InformationOfRegistration />
  </PageLayout>
);

export default InformationOfRegistrationPage;
